import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { ReactNode } from 'react';

const styles = StyleSheet.create({
  sectionHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    fontFamily: 'Janna',
  },

  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2A186A',
    fontFamily: 'Janna',
  },

  sectionDivider: {
    width: 16,
    height: 2,
    backgroundColor: '#D81059',
  },
});

const ReportSectionHeader = ({ title, currentLanguage }: { title: ReactNode; currentLanguage?: string }) => {
  return (
    <View style={currentLanguage === 'ar' ? [styles.sectionHeader, { alignItems: 'flex-end' }] : styles.sectionHeader}>
      {typeof title === 'string' || typeof title === 'number' ? (
        <Text style={styles.sectionTitle}>{title}</Text>
      ) : (
        title
      )}
      <View style={styles.sectionDivider} />
    </View>
  );
};

export default ReportSectionHeader;
